import React from 'react'
import { formatDate } from '../../../utils/formartDates'
import { useNavigate } from 'react-router-dom';
import { GrView } from "react-icons/gr";


export const CourseList = ({ courses = [] }) => {
    const navigate = useNavigate()

    const handleCourse = (courseId) => {
        navigate("/app/course-view", {
            state: { courseId }
        });
    };

  return (
      <div className="overflow-x-auto rounded-xl shadow-md border border-gray-200">
          <table className="min-w-full text-sm text-left bg-white">
              {/* HEADER */}
              <thead className="bg-primary-100 text-primary-600 capitalize text-xs">
                  <tr>
                      <th className="p-3 whitespace-nowrap border text-center">Sl.no</th>
                      <th className="p-3 whitespace-nowrap border text-center">Course Code</th>
                      <th className="p-3 whitespace-nowrap border text-center">Course Name</th>
                      <th className="p-3 whitespace-nowrap border text-center">Department</th>
                      <th className="p-3 whitespace-nowrap border text-center">Created By</th>
                      <th className="p-3 whitespace-nowrap border text-center">Created At</th>
                      <th className="px-5 py-3 text-center">Actions</th>
                  </tr>
              </thead>
              {/* BODY */}
              <tbody className="divide-y divide-gray-100">
                  {courses.length === 0 ? (
                      <tr>
                          <td colSpan="7" className="py-10 text-center text-gray-400">
                              No courses found
                          </td>
                      </tr>
                  ) : (
                      courses.map((co, i) => (
                          <tr
                              key={co?._id}
                              className="hover:bg-gray-50 transition duration-150"
                          >
                              <td className="p-3 whitespace-nowrap border text-center">
                                  {i + 1}
                              </td>

                              {/* Course Code */}
                              <td className="p-3 whitespace-nowrap border text-center">
                                  {co?.code || "-"}
                              </td>

                              {/* Course Title */}
                              <td className="p-3 whitespace-nowrap border ">
                                  {co?.title || "-"}
                              </td>

                              {/* Department */}
                              <td className="p-3 whitespace-nowrap border text-center">
                                  {co?.department?.name || "-"}
                              </td>

                              {/* Created By */}
                              <td className="p-3 whitespace-nowrap border text-center">
                                  {co?.createdBy?.fullName || "-"}
                              </td>

                              {/* Created Date */}
                              <td className="p-3 whitespace-nowrap border text-center">
                                  {formatDate(co?.createdAt)}
                              </td>

                              {/* ACTIONS */}
                              <td className="p-3 whitespace-nowrap border text-center space-x-2">
                                  <button title='view' onClick={()=>handleCourse(co?._id)} className="px-3 py-1 text-xs rounded text-primary-700  transition">
                                      <GrView size={20} />
                                  </button>
                              </td>
                          </tr>
                      ))
                  )}
              </tbody>
          </table>
      </div>
  )
}
